import { WIRChecklistTypes } from 'pages/WellGuardian/WIR/wir.constants';
import { WIRCheckSection } from 'types/wellGuardian';

export const getCheckSection = (checkType: string) => {
  switch (checkType) {
    case WIRChecklistTypes.GENERIC:
      return WIRCheckSection.GENERIC;
    case WIRChecklistTypes.PRODUCTION_AND_RESERVIOR:
      return WIRCheckSection.PRODUCTION_AND_RESERVOIR;
    case WIRChecklistTypes.PUMPING_OPERATION:
      return WIRCheckSection.PUMPING_OPERATION;
    case WIRChecklistTypes.PERFORATIONS:
      return WIRCheckSection.PERFORATIONS;
    case WIRChecklistTypes.WELL_STIMULATION:
      return WIRCheckSection.WELL_STIMULATION;
  }
};
